export const reviewEntityTs = `import { DeepPartial } from '@vendure/common/lib/shared-types'
import { VendureEntity, Product, Customer, ID } from '@vendure/core'
import { Column, Entity, ManyToOne, Index } from 'typeorm'

/**
 * Here we define a new database entity. Entities are used to define the shape of the data
 * that will be stored in the database. This Review entity defines a product review system.
 */
@Entity()
export class Review extends VendureEntity {
  constructor(input?: DeepPartial<Review>) {
    super(input)
  }

  @Index()
  @ManyToOne(() => Product, { onDelete: 'CASCADE' })
  product: Product

  @Column()
  productId: ID

  @Index()
  @ManyToOne(() => Customer, { onDelete: 'CASCADE' })
  customer: Customer

  @Column()
  customerId: ID

  @Column()
  rating: number

  @Column({ type: 'text' })
  content: string

  @Column({ default: false })
  approved: boolean

  @Column({ default: 0 })
  upvotes: number

  @Column({ default: 0 })
  downvotes: number
}
`
